import { Section } from '../UI/IgmtInk'
import Cetaphil from '../../assets/Cetaphil-min.png'
import CetaphilWebp from '../../assets/Cetaphil.webp'
import UniLove from '../../assets/UniLove-min.png'
import UniLoveWebp from '../../assets/UniLove.webp'
import Johnsons from '../../assets/Johnsons-min.png'
import JohnsonsWebp from '../../assets/Johnsons.webp'
import Bonakid from '../../assets/Bonakid-min.png'
import BonakidWebp from '../../assets/Bonakid.webp'
import Lampien from '../../assets/Lampien-min.png'
import LampienWebp from '../../assets/Lampien.webp'
import Cerelac from '../../assets/Cerelac-min.png'
import CerelacWebp from '../../assets/Cerelac.webp'
import BabyClothes from '../../assets/BabyClothes-min.png'
import BabyClothesWebp from '../../assets/BabyClothes.webp'
import Money from '../../assets/Money-min.png'
import MoneyWebp from '../../assets/Money.webp'
import LovePray from '../../assets/LovePray-min.png'
import LovePrayWebp from '../../assets/LovePray.webp'

const GiftIdeas = props => {
  return (
    <Section
      attr={{ id: 'giftIdeas' }}
      className="p-9 lg:py-24 bg-[#f9f9f9] animate-slide-down"
    >
      <h2 className='mb-8 md:mb-14 lg:mb-16 text-center font-bold font-["Courgette"] text-blue-500 text-4xl md:text-6xl'>
        Gift Ideas
      </h2>
      <div className="grid grid-auto-fit-sm gap-4">
        <div className="bg-white rounded-md h-[14.25rem] text-center p-4 grid grid-cols-1 gap-4 justify-items-center items-center shadow-md">
          <picture className="self-end">
            <source srcSet={CetaphilWebp} type="image/webp" />
            <source srcSet={Cetaphil} type="image/png" />

            <img
              className="w-1/2 mx-auto"
              src={CetaphilWebp}
              alt="Cetaphil Logo"
            />
          </picture>
          <h3 className="self-start text-lg font-bold">Cetaphil Products</h3>
        </div>
        <div className="bg-white rounded-md h-[14.25rem] text-center p-4 grid grid-cols-1 gap-4 justify-items-center items-center shadow-md">
          <picture className="self-end">
            <source srcSet={UniLoveWebp} type="image/webp" />
            <source srcSet={UniLove} type="image/png" />

            <img
              className="w-1/2 mx-auto"
              src={UniLoveWebp}
              alt="Uni-Love Logo"
            />
          </picture>{' '}
          <h3 className="self-start text-lg font-bold">Uni-Love Products</h3>
        </div>
        <div className="bg-white rounded-md h-[14.25rem] text-center p-4 grid grid-cols-1 gap-4 justify-items-center items-center shadow-md">
          <picture className="self-end">
            <source srcSet={JohnsonsWebp} type="image/webp" />
            <source srcSet={Johnsons} type="image/png" />

            <img
              className="w-1/2 mx-auto"
              src={JohnsonsWebp}
              alt="Johnson & Johnsons Logo"
            />
          </picture>
          <h3 className="self-start text-lg font-bold">Johnsons Products</h3>
        </div>
        <div className="bg-white rounded-md h-[14.25rem] text-center p-4 grid grid-cols-1 gap-4 justify-items-center items-center shadow-md">
          <picture className="self-end">
            <source srcSet={BonakidWebp} type="image/webp" />
            <source srcSet={Bonakid} type="image/png" />

            <img
              className="w-1/2 mx-auto"
              src={BonakidWebp}
              alt="Bonakid Logo"
            />
          </picture>
          <h3 className="self-start text-lg font-bold">Bonakid 1+</h3>
        </div>
        <div className="bg-white rounded-md h-[14.25rem] text-center p-4 grid grid-cols-1 gap-4 justify-items-center items-center shadow-md">
          <picture className="self-end">
            <source srcSet={LampienWebp} type="image/webp" />
            <source srcSet={Lampien} type="image/png" />

            <img
              className="w-1/2 mx-auto"
              src={LampienWebp}
              alt="Lampien Logo"
            />
          </picture>
          <h3 className="self-start text-lg font-bold">
            Lampien Diaper (Large)
          </h3>
        </div>
        <div className="bg-white rounded-md h-[14.25rem] text-center p-4 grid grid-cols-1 gap-4 justify-items-center items-center shadow-md">
          <picture className="self-end">
            <source srcSet={CerelacWebp} type="image/webp" />
            <source srcSet={Cerelac} type="image/png" />

            <img
              className="w-1/2 mx-auto"
              src={CerelacWebp}
              alt="Cerelac Logo"
            />
          </picture>
          <h3 className="self-start text-lg font-bold">Cerelac / Baby Food</h3>
        </div>
        <div className="bg-white rounded-md h-[14.25rem] text-center p-4 grid grid-cols-1 gap-4 justify-items-center items-center shadow-md">
          <picture className="self-end">
            <source srcSet={BabyClothesWebp} type="image/webp" />
            <source srcSet={BabyClothes} type="image/png" />

            <img
              className="w-1/2 mx-auto"
              src={CerelacWebp}
              alt="Baby Boy Clothes Vector"
            />
          </picture>
          <h3 className="self-start text-lg font-bold">Baby Clothes</h3>
        </div>
        <div className="bg-white rounded-md h-[14.25rem] text-center p-4 grid grid-cols-1 gap-4 justify-items-center items-center shadow-md">
          <picture className="self-end">
            <source srcSet={MoneyWebp} type="image/webp" />
            <source srcSet={Money} type="image/png" />

            <img
              className="w-1/2 mx-auto"
              src={MoneyWebp}
              alt="Money Illustration"
            />
          </picture>
          <h3 className="self-start text-lg font-bold">
            Monetary <br /> (For Savings of Baby Ali)
          </h3>
        </div>
        <div className="bg-white rounded-md h-[14.25rem] text-center p-4 grid grid-cols-1 gap-4 justify-items-center items-center shadow-md">
          <picture className="self-end">
            <source srcSet={LovePrayWebp} type="image/webp" />
            <source srcSet={LovePray} type="image/png" />

            <img
              className="w-1/2 mx-auto"
              src={LovePrayWebp}
              alt="Love & Pray Illustration"
            />
          </picture>
          <h3 className="self-start text-lg font-bold">Love & Pray</h3>
        </div>
      </div>

      <p className="text-blue-500 text-center font-bold mt-8 md:mt-14 lg:mt-16 sm:text-lg sm:max-w-md md:text-xl md:max-w-xl lg:text-2xl mx-auto">
        Just because we gave ideas doesn’t mean you are obligated to give. Your
        presence is the most precious gift you can give.
      </p>
    </Section>
  )
}

export default GiftIdeas
